import { useQuery } from '@tanstack/react-query';

import { Declarant } from '@e-origin/shared';

import { MILLISECONDS_IN_SECOND, SECONDS_IN_MINUTE, STALE_TIME_USE_DECLARANT_MIN } from '@constants';
import { showErrorToast } from '@hooks/showErrorToast';
import { request } from '@utils';

export const useDeclarants = () => {
  return useQuery({
    queryKey: ['declarants'],
    staleTime: MILLISECONDS_IN_SECOND * SECONDS_IN_MINUTE * STALE_TIME_USE_DECLARANT_MIN, // 10 min
    queryFn: async (): Promise<Declarant[]> => {
      try {
        const { data } = await request({
          path: `declarant`,
          method: 'GET',
          authenticate: true,
        });

        return data;
      } catch (error) {
        showErrorToast(error, 'Failed to fetch declarants');
      }
    },
    placeholderData: [],
  });
};
